import React from 'react';
import { render, screen } from '@testing-library/react';
import Icon from './Icon';

jest.mock('./icons', () => ({
  __esModule: true,
  default: {
    check: '<svg data-testid="svg-check"><path d="M0 0"/></svg>',
    close: '<svg data-testid="svg-close"><path d="M0 0"/></svg>',
    search: '<svg data-testid="svg-search"><path d="M0 0"/></svg>',
  },
}));

describe('Icon', () => {
  it('renders the SVG for a valid icon name', () => {
    const { container } = render(<Icon name="check" />);
    expect(container.querySelector('svg')).toBeInTheDocument();
  });

  it('returns null for an unknown icon name', () => {
    const { container } = render(<Icon name="nonexistent" />);
    expect(container.firstChild).toBeNull();
  });

  it('applies size class', () => {
    const { container } = render(<Icon name="check" size="lg" />);
    expect(container.firstChild).toHaveClass('size-lg');
  });

  it('defaults to md size', () => {
    const { container } = render(<Icon name="check" />);
    expect(container.firstChild).toHaveClass('size-md');
  });

  it('applies color class', () => {
    const { container } = render(<Icon name="check" color="talent" />);
    expect(container.firstChild).toHaveClass('color-talent');
  });

  it('does not apply color class when no color', () => {
    const { container } = render(<Icon name="check" />);
    const el = container.firstChild as HTMLElement;
    const hasColorClass = Array.from(el.classList).some((c: string) => c.startsWith('color-'));
    expect(hasColorClass).toBe(false);
  });

  it('applies weight class', () => {
    const { container } = render(<Icon name="check" weight="bold" />);
    expect(container.firstChild).toHaveClass('weight-bold');
  });

  it('applies custom className', () => {
    const { container } = render(<Icon name="check" className="custom" />);
    expect(container.firstChild).toHaveClass('custom');
  });

  describe('accessibility', () => {
    it('is aria-hidden by default (decorative)', () => {
      const { container } = render(<Icon name="check" />);
      expect(container.firstChild).toHaveAttribute('aria-hidden', 'true');
    });

    it('removes aria-hidden when aria-label is provided', () => {
      const { container } = render(<Icon name="check" aria-label="Checkmark" />);
      expect(container.firstChild).not.toHaveAttribute('aria-hidden');
    });

    it('sets role="img" when aria-label is provided', () => {
      render(<Icon name="check" aria-label="Checkmark" />);
      expect(screen.getByRole('img', { name: 'Checkmark' })).toBeInTheDocument();
    });

    it('does not set role="img" when decorative', () => {
      const { container } = render(<Icon name="check" />);
      expect(container.firstChild).not.toHaveAttribute('role');
    });

    it('supports explicit aria-hidden=false', () => {
      const { container } = render(<Icon name="check" aria-hidden={false} />);
      expect(container.firstChild).toHaveAttribute('aria-hidden', 'false');
    });

    it('supports custom role', () => {
      const { container } = render(<Icon name="check" role="presentation" aria-hidden={false} />);
      expect(container.firstChild).toHaveAttribute('role', 'presentation');
    });
  });
});
